module.exports = __webpack_public_path__ + "files/7e30e0a624c04c45463f20156f0a4270.png";